import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ContactEffects, contactReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([ContactEffects]), StoreModule.forFeature(`contact`, contactReducer)]
})
export class ContactStateModule {}
